export default `
mutation amPromoAddFreeGiftsToCart($cartId: String!, $promoItems: [amPromoItemInput!]){
  amPromoAddFreeGiftsToCart(cartId: $cartId, promoItems: $promoItems) {
    user_errors
  }
}
`;
